import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconSaturn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSaturn"><G ClipPath="url(#clip0_15669_27794)"><Circle cx="12" cy="12" r="8" stroke="currentColor"/><Path d="M4.002 12.1714C1.65103 13.5139 0.302225 14.825 0.589207 15.7082C1.1012 17.284 6.62589 16.9012 12.9289 14.8532C19.232 12.8052 23.9266 9.86759 23.4146 8.29182C23.125 7.40066 21.2322 7.13593 18.502 7.44456" stroke="currentColor"/></G><Defs><ClipPath id="clip0_15669_27794"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconSaturn;
